"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _elementUi = require("element-ui");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    form: {
      type: Object
    },
    bkYardDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      return this.bkYardDiff.includes(fileName);
    }
  }
};